const FundingSources = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'taxes', value: 81 },
    { type: 'state park fees', value: 5 },
    { type: 'development fees', value: 3 },
    { type: 'wastewater surcharge', value: 3 },
    { type: 'other', value: 8 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const FundingSplit = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'Pollution Abatement Projects', value: 60 },
    { type: 'Special Projects', value: 40 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const CIPTable = () => {
  const CIPData = [
    {
      'Project Title': 'Tower Loop Shoreline Stabilization Phase II',
      'Total': '$1,035',
      'Authority Portion': '$1,035',
      'Proposed 2026 Budget': '$ -',
      'Out-year Budget': '$1,035',
      'Funding Year(s)': '2034-2035',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation at Main Street (Parker) -Reach A',
      'Total': '$5,625',
      'Authority Portion': '$1,125',
      'Proposed 2026 Budget': '$125',
      'Out-year Budget': '$1,125',
      'Funding Year(s)': '2026-2028',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation at Main Street (Parker) - Reach B',
      'Total': '$5,625',
      'Authority Portion': '$1,125',
      'Proposed 2026 Budget': '$0',
      'Out-year Budget': '$1,125',
      'Funding Year(s)': '2029-2030',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation at Main Street (Parker) - Reach C',
      'Total': '$5,625',
      'Authority Portion': '$1,125',
      'Proposed 2026 Budget': '$0',
      'Out-year Budget': '$1,125',
      'Funding Year(s)': '2031-2032',
    },
    {
      'Project Title':
          'Cherry Creek Stream Reclamation at Arapahoe Rd. - Valley Country Club to Soccer Fields, Reaches 3 to 4',
      'Total': '$12,469',
      'Authority Portion': '$2,166',
      'Proposed 2026 Budget': '$200',
      'Out-year Budget': '$939',
      'Funding Year(s)': '2021-2030',
    },
    {
      'Project Title': 'Cherry Creek - Reservoir to Lake View Road (Reach 1 in CCSP) - FInal Design and Construction',
      'Total': '$13,494',
      'Authority Portion': '$3,703',
      'Proposed 2026 Budget': '$1,805',
      'Out-year Budget': 'TBD',
      'Funding Year(s)': '2025-2028',
    },
    {
      'Project Title': 'Cherry Creek Reaches 2 & 3 (in CCSP)',
      'Total': '$30,488',
      'Authority Portion': '$6,097',
      'Proposed 2026 Budget': '$ -',
      'Out-year Budget': '$6,097',
      'Funding Year(s)': '2029-',
    },
    {
      'Project Title': 'Piney Creek - Cherry Creek to Parker Road, Reaches 1 to 2 (SEMSWA)',
      'Total': '$4,060',
      'Authority Portion': '$930',
      'Proposed 2026 Budget': '$75',
      'Out-year Budget': '$621',
      'Funding Year(s)': '2022-2030',
    },
    {
      'Project Title': 'Piney Creek south of Orchard Rd., Reaches 4 to 5 (SEMSWA)',
      'Total': '$5,540',
      'Authority Portion': '$1,160',
      'Proposed 2026 Budget': '$235',
      'Out-year Budget': '$689',
      'Funding Year(s)': '2024-2029',
    },
    {
      'Project Title': 'Lone Tree Creek in CCSP downstream of Pond (CCBWQA Only)',
      'Total': '$600',
      'Authority Portion': '$600',
      'Proposed 2026 Budget': '$50',
      'Out-year Budget': '$600',
      'Funding Year(s)': '2026-2030',
    },
    {
      'Project Title': 'Lone Tree Creek in CCSP upstream of Pond (Centennial Trail Portion)',
      'Total': '$448',
      'Authority Portion': '$112',
      'Proposed 2026 Budget': '$112',
      'Out-year Budget': '$112',
      'Funding Year(s)': '2026',
    },
    {
      'Project Title': 'Happy Canyon Creek at Jordan Road (SEMSWA)',
      'Total': '$5,523',
      'Authority Portion': '$1,031',
      'Proposed 2026 Budget': '$200',
      'Out-year Budget': '$300',
      'Funding Year(s)': '2021-2027',
    },
    {
      'Project Title': 'Cottonwood Creek at Inverness',
      'Total': '$6,350',
      'Authority Portion': 'TBD',
      'Proposed 2026 Budget': '$25',
      'Out-year Budget': 'TBD',
      'Funding Year(s)': '2026-2031',
    },
    {
      'Project Title': 'SCM Retrofit Project',
      'Total': 'TBD',
      'Authority Portion': '$100',
      'Proposed 2026 Budget': '$100',
      'Out-year Budget': '$100',
      'Funding Year(s)': '2026',
    },
    {
      'Project Title': 'PRF Preservation, Acquisition, Lease of Land or Water',
      'Total': '$100',
      'Authority Portion': '$100',
      'Proposed 2026 Budget': '$100',
      'Out-year Budget': '$100',
      'Funding Year(s)': '2026-2035',
    },
    {
      'Project Title': 'Total Capital Projects',
      'Total': '$96,982',
      'Authority Portion': '$20,409',
      'Proposed 2026 Budget': '$3,027',
      'Out-year Budget': '$13,968',
      'Funding Year(s)': '',
    },
  ];

  const OandMData = [
    { Item: 'Repairs and Maintenance', 'Proposed 2026 Budget': '$108' },
    { Item: 'Restoration', 'Proposed 2026 Budget': '$0' },
    { Item: 'Reservoir Destratification Service Plan', 'Proposed 2026 Budget': '$41' },
    { Item: 'Meteorlogical Station Service', 'Proposed 2026 Budget': '$3' },
    { Item: 'Weed Control', 'Proposed 2026 Budget': '$11' },
    { Item: 'Wetland Harvesting', 'Proposed 2026 Budget': '$109' },
    { Item: 'Utilities - Reservoir Destratification', 'Proposed 2026 Budget': '$76' },
    { Item: 'RDS Rehabilitation', 'Proposed 2026 Budget': '$47' },
    { Item: 'Total Operations & Maintenance', 'Proposed 2026 Budget': '$395' },
  ];

  const table = new requestTable({
    container: '#cip-table',
    filterEnabled: false,
    tableHeaders: {
      'Project Title': 'Project Title',
      Total: 'Current Total Budget',
      'Authority Portion': 'Current Authority Portion',
      'Proposed 2026 Budget': 'Proposed 2026 Budget',
      'Out-year Budget': 'Out-year Budget',
      'Funding Year(s)': 'Funding Year(s)',
    },
    tableActions: [],
    tableData: CIPData,
  });
  table.buildTable();

  const omTable = new requestTable({
    container: '#cip-om-table',
    filterEnabled: false,
    tableHeaders: {
      Item: 'Operations & Maintenance',
      'Proposed 2026 Budget': 'Proposed 2026 Budget',
    },
    tableActions: [],
    tableData: OandMData,
  });
  omTable.buildTable();
};